/* Visser header: hoogte-variabelen, uitklapbaar zoekveld, mobiel menu, sticky-offset voor de seizoensbalk. */
(function () {
  'use strict';

  var root = document.documentElement;

  function measure() {
    var header = document.getElementById('vc-header');
    var bar = document.getElementById('vcSeasonBar');
    var h = header ? header.offsetHeight : 0;
    var b = bar ? bar.offsetHeight : 0;
    root.style.setProperty('--vc-header-height', h + 'px');
    root.style.setProperty('--vc-seasonbar-height', b + 'px');
    /* Luxe-onderdelen (cart drawer, policy-pagina's) rekenen met deze variabelen. */
    root.style.setProperty('--site-header-height-mobile', (h + b) + 'px');
    root.style.setProperty('--site-header-height-desktop', (h + b) + 'px');
  }

  var openSearch = function () {};
  var closeSearch = function () {};
  var closeMenu = function () {};

  function bind() {
    measure();
    var header = document.getElementById('vc-header');
    if (header && window.ResizeObserver && !header.__vcObserved) {
      header.__vcObserved = true;
      new ResizeObserver(measure).observe(header);
    }

    /* ---- Zoeken: de knop opent een zoekpaneel onder de logobalk (desktop en telefoon gelijk) ---- */
    var box = document.getElementById('vcSearch');
    var panel = document.getElementById('vcSearchPanel');
    var toggle = document.getElementById('vcSearchOpen');
    var close = document.getElementById('vcSearchClose');
    var input = document.getElementById('vcSearchInput');
    var focusables = panel ? panel.querySelectorAll('input:not([type="hidden"]), button') : [];

    function setTabbable(on) {
      Array.prototype.forEach.call(focusables, function (el) { if (on) el.removeAttribute('tabindex'); else el.setAttribute('tabindex', '-1'); });
    }
    openSearch = function () {
      if (!box || box.classList.contains('is-open')) { if (input) input.focus(); return; }
      closeMenu();
      box.classList.add('is-open');
      panel && panel.setAttribute('aria-hidden', 'false');
      toggle && toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('vc-search-open');
      setTabbable(true);
      /* Direct (binnen de klik) focussen: alleen dan opent iOS het toetsenbord. */
      if (input) {
        try { input.focus({ preventScroll: true }); } catch (err) { input.focus(); }
        var v = input.value; if (v) { try { input.setSelectionRange(v.length, v.length); } catch (err) {} }
        /* Stond er al een zoekterm met resultaten? Laat die weer zien. */
        var results = box.querySelector('#predictive-search');
        if (results && v.trim().length && results.innerHTML.trim().length) results.style.display = 'block';
      }
    };
    closeSearch = function (restoreFocus) {
      if (!box || !box.classList.contains('is-open')) return;
      box.classList.remove('is-open', 'is-loading');
      panel && panel.setAttribute('aria-hidden', 'true');
      toggle && toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('vc-search-open');
      setTabbable(false);
      if (input) input.blur();
      var results = box.querySelector('#predictive-search');
      if (results) results.style.display = 'none';
      if (restoreFocus === true && toggle) toggle.focus();
    };
    if (box && toggle && !toggle.__vcBound) {
      toggle.__vcBound = true;
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        if (box.classList.contains('is-open')) closeSearch(true); else openSearch();
      });
      close && close.addEventListener('click', function () { closeSearch(true); });
      /* Klik op de waas onder het paneel sluit het zoeken */
      panel && panel.addEventListener('click', function (e) { if (e.target === panel) closeSearch(); });
      input && input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && !input.value.trim().length) e.preventDefault();
      });
    }
    /* Zoeken in het mobiele menu opent hetzelfde paneel */
    var drawerSearch = document.getElementById('vcDrawerSearch');
    if (drawerSearch && box && !drawerSearch.__vcBound) {
      drawerSearch.__vcBound = true;
      drawerSearch.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); closeMenu(); openSearch(); });
    }

    /* ---- Mobiel menu ---- */
    var mOpen = document.getElementById('vcMenuOpen');
    var mClose = document.getElementById('vcMenuClose');
    var drawer = document.getElementById('vcDrawer');
    var bg = document.getElementById('vcDrawerBg');

    function openMenu() {
      if (!drawer) return;
      closeSearch();
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      bg && bg.classList.add('is-open');
      mOpen && mOpen.setAttribute('aria-expanded', 'true');
      document.body.classList.add('vc-menu-open', 'overflow-hidden');
      setTimeout(function () { drawer.focus(); }, 40);
    }
    closeMenu = function () {
      if (!drawer || !drawer.classList.contains('is-open')) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      bg && bg.classList.remove('is-open');
      mOpen && mOpen.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('vc-menu-open', 'overflow-hidden');
      mOpen && mOpen.focus();
    };
    if (mOpen && drawer && !mOpen.__vcBound) {
      mOpen.__vcBound = true;
      mOpen.addEventListener('click', openMenu);
      mClose && mClose.addEventListener('click', closeMenu);
      bg && bg.addEventListener('click', closeMenu);
    }
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeSearch(true); closeMenu(); }
  });
  /* Klik buiten het zoekveld sluit het weer */
  document.addEventListener('click', function (e) {
    var box = document.getElementById('vcSearch');
    if (box && box.classList.contains('is-open') && !box.contains(e.target)) closeSearch();
  });

  /* Harde blokkade: als de pagina toch zijwaarts verschuift (iOS), meteen terugzetten.
     Niet doen wanneer de bezoeker heeft ingezoomd, want dan moet zijwaarts kijken juist wel. */
  function vcZoomed() { return !!(window.visualViewport && window.visualViewport.scale > 1.01); }
  function vcSnapBack() { if (window.scrollX && !vcZoomed()) window.scrollTo(0, window.scrollY); }
  window.addEventListener('scroll', vcSnapBack, { passive: true });
  window.addEventListener('touchend', vcSnapBack, { passive: true });

  /* Menu sluiten bij overgang naar desktop */
  var mq = window.matchMedia('(min-width: 1025px)');
  var onMedia = function (m) { if (m.matches) closeMenu(); };
  if (mq.addEventListener) mq.addEventListener('change', onMedia); else mq.addListener(onMedia);

  /* ---- Ankerlinks (bijv. /#doosje): scrollen met ruimte voor de vaste header, ook na het laden ---- */
  function headerOffset() {
    var header = document.getElementById('vc-header');
    return (header ? header.offsetHeight : 0) + 12;
  }
  function scrollToHash(hash, smooth) {
    if (!hash || hash.length < 2) return false;
    var el = document.getElementById(decodeURIComponent(hash.slice(1)));
    if (!el) return false;
    var top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({ top: Math.max(0, top), behavior: smooth ? 'smooth' : 'auto' });
    return true;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href*="#"]');
    if (!a) return;
    var url;
    try { url = new URL(a.getAttribute('href'), location.href); } catch (err) { return; }
    if (url.hash.length < 2 || url.pathname !== location.pathname || url.origin !== location.origin) return;
    if (!document.getElementById(decodeURIComponent(url.hash.slice(1)))) return;
    e.preventDefault();
    closeMenu();
    try { history.pushState(null, '', url.hash); } catch (err) {}
    scrollToHash(url.hash, true);
  });
  var startHash = location.hash;
  if (startHash && startHash.length > 1) {
    [0, 300, 900, 1800, 3200].forEach(function (t) { setTimeout(function () { scrollToHash(startHash, false); }, t); });
  }

  /* ---- Webshop-kant tonen op een gedeelde pagina (bijv. Contact) via ?m=shop of ?m=brand ---- */
  function applyModeFromQuery() {
    var header = document.getElementById('vc-header');
    if (!header) return;
    var want = null;
    try { want = new URLSearchParams(location.search).get('m'); } catch (err) {}
    if (!want || (want !== 'shop' && want !== 'brand') || header.dataset.mode === want) return;
    var lists = header.querySelectorAll('.vc-nav__list[data-nav]');
    if (!lists.length) return;
    header.dataset.mode = want;
    lists.forEach(function (ul) { ul.hidden = ul.dataset.nav !== want; });
    header.querySelectorAll('.vc-mode__item[data-mode-item]').forEach(function (a) {
      var on = a.dataset.modeItem === want;
      a.classList.toggle('is-on', on);
      if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyModeFromQuery);
  else applyModeFromQuery();

  /* ---- Overgang bij de schakelaar Webshop / Over Visser (2026-09-28) ----
     Het zwarte blok schuift eerst naar de andere kant en een vlak in de seizoenstint veegt over de pagina.
     Daarna gaat de browser naar de nieuwe pagina; daar veegt het vlak weer weg en komt de hero binnen
     (zie snippets/vc-motion.liquid). */
  var switching = false;
  function reducedMotion() { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }
  function setModeUI(header, want) {
    header.dataset.mode = want;
    header.querySelectorAll('.vc-mode__item[data-mode-item]').forEach(function (a) {
      var on = a.dataset.modeItem === want;
      a.classList.toggle('is-on', on);
      if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
    });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-mode-item]');
    if (!a) return;
    var header = document.getElementById('vc-header');
    if (!header || !header.hasAttribute('data-switch-anim')) return;
    var want = a.dataset.modeItem;
    if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (a.target && a.target !== '_self') return;
    if (want === header.dataset.mode || reducedMotion()) return;
    var url;
    try { url = new URL(a.href, location.href); } catch (err) { return; }
    if (url.origin !== location.origin) return;
    e.preventDefault();
    if (switching) return;
    switching = true;
    try { sessionStorage.setItem('vc-switch', want); sessionStorage.setItem('vc-switch-t', String(Date.now())); } catch (err) {}

    var inDrawer = !!a.closest('#vcDrawer');
    if (inDrawer) closeMenu();
    closeSearch();
    setModeUI(header, want);
    var lists = header.querySelectorAll('.vc-nav__list[data-nav]');
    var hasOther = Array.prototype.some.call(lists, function (ul) { return ul.dataset.nav === want; });
    if (hasOther) lists.forEach(function (ul) { ul.hidden = ul.dataset.nav !== want; });

    var group = header.closest('.header-group') || header;
    var top = Math.max(0, Math.round(group.getBoundingClientRect().bottom));
    var veil = document.createElement('span'); /* geen lege div: het basisthema verbergt div:empty */
    veil.className = 'vc-veil vc-veil--' + (want === 'shop' ? 'shop' : 'brand');
    veil.style.setProperty('--vc-veil-top', top + 'px');
    veil.setAttribute('aria-hidden', 'true');
    document.body.appendChild(veil);
    setTimeout(function () { location.href = url.href; }, inDrawer ? 420 : 520);
  });
  /* Vooruit laden zodra iemand over de schakelaar beweegt, zodat de nieuwe pagina direct klaarstaat */
  function prefetch(e) {
    var a = e.target.closest && e.target.closest('a[data-mode-item]');
    if (!a || a.__vcPrefetched || a.classList.contains('is-on')) return;
    a.__vcPrefetched = true;
    var l = document.createElement('link');
    l.rel = 'prefetch'; l.href = a.href;
    document.head.appendChild(l);
  }
  document.addEventListener('pointerover', prefetch, { passive: true });
  document.addEventListener('touchstart', prefetch, { passive: true });
  /* Terug met de knop 'vorige' (pagina uit de cache): overgang opruimen en de schakelaar terugzetten */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    switching = false;
    document.querySelectorAll('.vc-veil').forEach(function (v) { v.parentNode.removeChild(v); });
    try { sessionStorage.removeItem('vc-switch'); } catch (err) {}
    var header = document.getElementById('vc-header');
    if (header && header.dataset.modeInitial) {
      setModeUI(header, header.dataset.modeInitial);
      header.querySelectorAll('.vc-nav__list[data-nav]').forEach(function (ul) { ul.hidden = ul.dataset.nav !== header.dataset.modeInitial; });
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
  window.addEventListener('load', measure);
  window.addEventListener('resize', measure);

  /* Thema-editor: opnieuw binden wanneer de header-sectie herlaadt. */
  document.addEventListener('shopify:section:load', function () { setTimeout(bind, 50); });
  document.addEventListener('shopify:section:reorder', measure);
})();
